import styled, { css } from "styled-components";

import { CardHoverOverlay, CardPlayIcon } from "@pages/home/betto/casinoSlider/elements";

const glassCardBorder = css`
	isolation: isolate;

	&::after {
		content: "";
		position: absolute;
		inset: 0;
		border-radius: inherit;
		border: 1px solid #ffffff;
		mix-blend-mode: overlay;
		pointer-events: none;
		z-index: 2;
	}
`;

export const BettoCollectionPage = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 100%;
	padding: 0 0 32px;
	box-sizing: border-box;

	#casino-filters-container {
		margin-bottom: 20px;
	}
`;

export const BettoCollectionContent = styled.div`
	width: 100%;
	max-width: 100%;
	box-sizing: border-box;
`;

export const BettoCollectionTopRow = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	margin: 8px 0 24px;
`;

export const BettoCollectionBackButton = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	padding: 0;
	border: none;
	border-radius: 10px;
	background: transparent;
	cursor: pointer;
	appearance: none;
	-webkit-appearance: none;
	outline: none;
	box-shadow: none;

	&:focus,
	&:focus-visible {
		outline: none;
		box-shadow: none;
	}

	&:hover {
		background: rgba(255, 255, 255, 0.06);
	}
`;

export const BettoCollectionBackIcon = styled.img`
	width: 24px;
	height: 24px;
	display: block;
	transform: rotate(180deg);
`;

export const BettoCollectionHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	margin: 0;
	color: #e5f0fe;
	font-family: var(--bt-font-family);
	font-size: 22px;
	font-weight: 400;
	line-height: 1.1;

	img {
		flex-shrink: 0;
		width: 24px;
		height: 24px;
		object-fit: contain;
	}
`;

export const BettoCollectionHeaderDot = styled.span`
	flex-shrink: 0;
	width: 18px;
	height: 18px;
	border-radius: 50%;
	background: var(--main-color);
`;

export const BettoCollectionGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 144px);
	gap: 12px;
	width: 100%;
	justify-content: start;

	@media (min-width: 640px) {
		grid-template-columns: repeat(4, 144px);
	}

	@media (min-width: 900px) {
		grid-template-columns: repeat(5, 144px);
	}

	@media (min-width: 1100px) {
		grid-template-columns: repeat(7, 144px);
	}
`;

export const BettoSliderCollectionCardWrap = styled.div`
	position: relative;
	width: 100%;
	aspect-ratio: ${({ $aspectRatio = "4 / 5" }) => $aspectRatio};
	border-radius: 12px;
	box-sizing: border-box;
	overflow: hidden;
	cursor: pointer;
	z-index: 0;
	background: #171c2a;
	transition: transform 0.2s ease-in-out;
	${glassCardBorder}

	&:hover {
		transform: translateY(-12px);
		z-index: 2;
	}

	&:hover ${CardHoverOverlay} {
		opacity: 1;
		pointer-events: auto;
	}

	&:hover ${CardPlayIcon} {
		transform: translate(-50%, -50%);
	}
`;

export const BettoCollectionCardWrap = styled.div`
	position: relative;
	width: 144px;
	height: 144px;
	border-radius: 14px;
	box-sizing: border-box;
	overflow: hidden;
	cursor: pointer;
	z-index: 0;
	background: #171c2a;
	transition: transform 0.2s ease-in-out;
	${glassCardBorder}

	&:hover {
		transform: translateY(-12px);
		z-index: 2;
	}

	&:hover ${CardHoverOverlay} {
		opacity: 1;
		pointer-events: auto;
	}

	&:hover ${CardPlayIcon} {
		transform: translate(-50%, -50%);
	}
`;

export const BettoBrowseGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	gap: 12px;
	width: 100%;

	@media (min-width: 640px) {
		grid-template-columns: repeat(4, minmax(0, 1fr));
	}

	@media (min-width: 900px) {
		grid-template-columns: repeat(5, minmax(0, 1fr));
	}

	@media (min-width: 1100px) {
		grid-template-columns: repeat(7, minmax(0, 1fr));
	}
`;
